import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LoginPageComponent implements OnInit {
  loginForm = new FormGroup({
    username: new FormControl('', Validators.required),
    password: new FormControl('', Validators.required),
    login_type: new FormControl("email")
  })

  // signupForm = new FormGroup({
  //   firstName: new FormControl('', Validators.required),
  //   lastName: new FormControl('', Validators.required),
  //   email: new FormControl('', [Validators.required, Validators.pattern(/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/)]),
  //   phone: new FormControl('', [Validators.required, Validators.pattern(/^\d{10}$/)]),
  //   passwordCreate: new FormControl('', Validators.required)
  // })
  constructor(private router: Router,
    private authService: AuthService,
    private _snackBar: MatSnackBar) { }

  ngOnInit(): void {
  }

  hide = true;

  swichBetweenLoginSignup(){
    this.router.navigate(['/signup']);
  }

  // handleSignUp(){
  //   console.log(this.signupForm);
  //   if (this.signupForm.valid) {
  //     const signupData = {
  //       ...this.signupForm.value,
  //     }
  //     console.log(signupData);

  //   }
  // }
  handleLogin(){
    console.log(this.loginForm);
    if (this.loginForm.valid) {
      const loginData = {
        ...this.loginForm.value,
      }
      console.log(loginData);

    }
    if (this.loginForm.valid) {
      let loginData;

      if (parseInt(this.loginForm.get('username').value)) {
        loginData = {
          phone: this.loginForm.get('username').value,
          password: this.loginForm.get('password').value,
          login_type: 'phone'
        }
      }
      else {
        loginData = {
          email: this.loginForm.get('username').value,
          password: this.loginForm.get('password').value,
          login_type: 'email'
        }
        
      }
      this.authService.login(loginData).subscribe(user => {
        console.log(user);
        if (user && user.authorization) {
          localStorage.setItem('authToken', user.authorization);
          console.log('This is local storage ',localStorage.getItem('authToken'));
          console.log('This is auth token ',user.authorization);
          localStorage.setItem('userInfo', JSON.stringify(user));
          this.router.navigateByUrl('/home');
        } else {
          this._snackBar.open('Incorrect credentials. Please try again.', 'OK', { duration: 3000 })
        }
      })
    }
    else {
      this._snackBar.open('Please fill all fields!', 'OK', { duration: 3000 })
    }
  }
    
  
}
